import instance from "../Service";

export default class Payment {
  static async buy_starter_pack_card() {
    return await instance.get("/pay/buy_starter_pack_card")
  }
  static async buy_growth_pack_card(){
    return await instance.get(`/pay/buy_growth_pack_card`)
  }
  static async buy_enterprise_pack_card(){
    return await instance.get(`/pay/buy_enterprise_pack_card`)
  }
  static async buy_starter_pack_invoice() {
    return await instance.get("/pay/buy_starter_pack")
  }
  static async buy_growth_pack_invoice(){
    return await instance.get(`/pay/buy_growth_pack`)
  }
  static async buy_enterprise_pack_invoice(){
    return await instance.get(`/pay/buy_enterprise_pack`)
  }
  static async processPrintOrderCard(data) {
    return await instance.post("/pay/order_print_qr_card", data);
  }

  static async processPrintOrderInvoice(data) {
    return await instance.post("/pay/order_print_qr", data);
  }

  static getDeliveryAddresses = async () => {
    try {
      const response = await instance.get('/delivery/addresses');
      return response;
    } catch (error) {
      console.error("API Error in getDeliveryAddresses:", error);
      // Возвращаем пустой набор данных вместо ошибки
      return { data: { Addresses: [] } };
    }
  };

  static updateDeliveryAddress = (addressId, addressData) => {
    return instance.put(`/delivery/addresses/${addressId}`, addressData);
  };
}
